"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayTableSelect = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const classnames_1 = __importDefault(require("classnames"));
const utils_1 = require("../utils/utils");
const attributes_matrix_selector_styles_1 = require("./attributes-matrix-selector/attributes-matrix-selector.styles");
const generic_1 = require("../../generic");
const action_select_styles_1 = require("../../generic/action-select/action-select.styles");
const localization_1 = require("../../../localization");
const DisplayTableSelect = ({ selectedOptions, onSelect, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handleApply = (selected) => {
        let finalSelected;
        if (selected === undefined) {
            // all options are selected.
            finalSelected = normalizedOptions.map((opt) => opt.value);
        }
        else if (selected === null) {
            // no options are selected.
            finalSelected = [];
        }
        else {
            // normal array of strings
            finalSelected = selected;
        }
        onSelect(finalSelected);
        setAnchorEl(null);
    };
    const isOpen = !!anchorEl;
    const normalizedOptions = [
        { label: t({ key: 'HIDE_EMPTY_COLUMNS' }), value: utils_1.DisplayTableOption.HideEmptyColumns },
        { label: t({ key: 'HIDE_EMPTY_ROWS' }), value: utils_1.DisplayTableOption.HideEmptyRows },
    ];
    return (react_1.default.createElement(attributes_matrix_selector_styles_1.StyledAttributeSection, null, react_1.default.createElement(action_select_styles_1.StyledAction, { color: "primary", title: t({ key: 'DISPLAY_TABLE' }), size: "small", className: (0, classnames_1.default)({ 'menu--open': isOpen }), endIcon: react_1.default.createElement(ui_components_1.Icon, { variant: isOpen ? 'chevronUp' : 'chevronDown' }), onClick: (event) => setAnchorEl(event.currentTarget) }), react_1.default.createElement(generic_1.MultiSelectMenu, { anchorEl: anchorEl, options: normalizedOptions, selected: selectedOptions, onApply: handleApply, onClose: () => setAnchorEl(null), allowEmptySelection: true })));
};
exports.DisplayTableSelect = DisplayTableSelect;
exports.default = exports.DisplayTableSelect;
